import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DrawerMode, WaitingListEntryDrawerSchema } from '../types';
import { Lead } from 'entities/Lead';
import { User } from 'entities/User';
import { WaitingListEntry } from 'entities/WaitingListEntry';

const initialState: WaitingListEntryDrawerSchema = {
  waitingListEntry: null,
  lead: null,
  mode: null,
  user: null,
};

const waitingListEntryDrawerSlice = createSlice({
  name: 'waitingListEntryDrawer',
  initialState,
  reducers: {
    setOpenWaitingListEntryDrawer: (
      state: WaitingListEntryDrawerSchema,
      action: PayloadAction<{
        mode: Nullable<DrawerMode>;
        waitingListEntry?: Nullable<WaitingListEntry>;
        lead?: Nullable<Lead>;
        user?: Nullable<User>;
      }>,
    ) => {
      state.mode = action.payload.mode;
      state.waitingListEntry = action.payload.waitingListEntry;
      state.lead = action.payload.lead;
      state.user = action.payload.user;
    },
  },
});

export const { actions: waitingListEntryDrawerActions, reducer: waitingListEntryDrawerReducer } = waitingListEntryDrawerSlice;
